import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, CardActions, CardContent, Grid, Paper, Typography } from '@availity/element';
import { getSpecificEnv } from '@availity/env-var';

import { AvailityHeaderLogo, Footer, NonProdBanner } from '@/components';

const currentEnv = getSpecificEnv();
const shouldShowNonProdBanner = currentEnv !== 'prod';

const NewUserVerified = () => {
  const navigate = useNavigate();

  return (
    <Grid
      id="new-user-verified-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        id="click-to-verify-page-content-grid"
        container
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
      >
        {shouldShowNonProdBanner ? (
          <Grid id="nonprod-banner-grid-container" display="flex" mx={2} mt={2} justifyContent="center">
            <NonProdBanner />
          </Grid>
        ) : (
          <Box />
        )}
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px' } }}>
            <CardContent>
              <Grid textAlign="center">
                <Typography variant="h1" mb={2}>
                  Your email has been verified!
                </Typography>
              </Grid>
            </CardContent>
            <CardActions>
              <Button color="primary" fullWidth onClick={() => navigate('/login')}>
                Take me to Login
              </Button>
            </CardActions>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </Grid>
  );
};

export default NewUserVerified;
